export const NUMBER_OF_IMAGES_PER_VIEW = {
  [true]: 3,
  [false]: 5,
};
